import React, { useRef } from "react";
import {
  FaChartBar,
  FaMoneyBillWave,
  FaBullseye,
  FaCalculator,
  FaSyncAlt,
  FaBrain,
  FaUsers,
  FaFileInvoiceDollar,
  FaLock,
  FaWifi,
  FaExchangeAlt,
  FaFileExport,
  FaMobileAlt,
  FaHandshake,
  FaChartLine,
  FaRandom,
  FaComments,
  FaCamera,
  FaBell,
  FaHeartbeat,
  FaMapMarkerAlt,
  FaExclamationTriangle,
} from "react-icons/fa";
// animations removed

const features = [
  {
    tier: "Essential",
    icon: <FaChartBar />,
    title: "Smart Dashboard",
    description: "Visualize income, expenses, loans & investments",
  },
  {
    tier: "Essential",
    icon: <FaMoneyBillWave />,
    title: "Expense Tracking",
    description: "Categorize & analyze your daily spend",
  },
  {
    tier: "Essential",
    icon: <FaFileInvoiceDollar />,
    title: "Detailed Budgets",
    description:
      "Create and track monthly or category-wise budgets effortlessly.",
  },
  {
    tier: "Essential",
    icon: <FaBullseye />,
    title: "Financial Goals",
    description: "Save for what matters, track your progress",
  },
  {
    tier: "Essential",
    icon: <FaMobileAlt />,
    title: "Mobile-Friendly Design",
    description: "Optimized for both desktop and mobile use cases.",
  },
  {
    tier: "Essential",
    icon: <FaLock />,
    title: "Data Privacy & Encryption",
    description: "All your financial data is encrypted and safely stored.",
  },
  {
    tier: "Advanced",
    icon: <FaHandshake />,
    title: "Borrow & Lend Tracking",
    description: "Track personal debts, repayments, and friendly dues easily.",
  },
  {
    tier: "Advanced",
    icon: <FaUsers />,
    title: "Split Bills with Friends",
    description:
      "Share expenses, track dues, and settle up easily with groups.",
  },
  {
    tier: "Advanced",
    icon: <FaSyncAlt />,
    title: "Recurring Transactions",
    description: "Subscriptions, premiums, & recurring goals",
  },
  {
    tier: "Advanced",
    icon: <FaExchangeAlt />,
    title: "Multi-Currency Support",
    description: "Track expenses and goals across different currencies.",
  },
  {
    tier: "Advanced",
    icon: <FaCalculator />,
    title: "Loan & EMI Calculator",
    description: "With prepayments, EMI/tenure toggle",
  },
  {
    tier: "Advanced",
    icon: <FaWifi />,
    title: "Offline Mode",
    description:
      "Access and edit your data even without internet. Auto-sync later.",
  },
  {
    tier: "Advanced",
    icon: <FaFileExport />,
    title: "Export & Backup",
    description: "Download your financial data as Excel or CSV anytime.",
  },
  {
    tier: "Advanced",
    title: "Smart Notifications",
    description: "Timely alerts for upcoming bills or overspending.",
    icon: <FaBell />,
  },

  {
    tier: "Intelligent",
    title: "Insights & Recommendations",
    description:
      "Automated analysis of your spending habits with tips to save more.",
    icon: <FaBrain />,
  },
  {
    tier: "Intelligent",
    title: "Cash Flow Forecasting",
    description: "Predict upcoming income and expenses using AI.",
    icon: <FaChartLine />,
  },
  {
    tier: "Intelligent",
    title: "Goal Optimization",
    description: "AI suggests ideal savings plans to hit goals on time.",
    icon: <FaBullseye />,
  },
  {
    tier: "Intelligent",
    title: "Auto-Budgeting",
    description: "Generate budgets based on your past behavior.",
    icon: <FaCalculator />,
  },
  {
    tier: "Intelligent",
    title: "What-If Simulator",
    description: "Test lifestyle changes and see budget impact.",
    icon: <FaRandom />,
  },
  {
    tier: "Intelligent",
    title: "Chatbot Assistant",
    description: "Ask 'How much did I spend on food last month?'",
    icon: <FaComments />,
  },
  {
    tier: "Intelligent",
    title: "Receipt Scanner",
    description: "Upload receipts and let AI auto-fill details.",
    icon: <FaCamera />,
  },
  {
    tier: "Intelligent",
    title: "Financial Health Score",
    description: "Track wellness and get personalized tips.",
    icon: <FaHeartbeat />,
  },
  {
    tier: "Intelligent",
    title: "Location-Aware Suggestions",
    description: "Reminders when entering stores you overspend at.",
    icon: <FaMapMarkerAlt />,
  },
  {
    tier: "Intelligent",
    title: "Anomaly Detection",
    description: "Flags duplicates or unusual spending patterns.",
    icon: <FaExclamationTriangle />,
  },
];

const Features = () => {
  const INITIAL_COUNT = 6;

  const cardRefs = useRef([]);

  // animations removed

  return (
    <>
      <section
        id="features-container"
        className="relative w-full overflow-hidden py-20 px-4 sm:px-6 lg:px-8"
      >
       
        <div className="relative z-10 text-center max-w-[900px] mx-auto mb-9">
     
          <h2 className="text-white font-extrabold tracking-tight text-[clamp(1.6rem,4.2vw,2.4rem)] mb-2">
            Powerful Features, Forever Free
          </h2>
          <p className="text-white/90 text-[clamp(1rem,2.2vw,1.15rem)]">
            Manage spending, goals, loans, and more.
          </p>
        </div>
        <div className="relative z-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 max-w-[1200px] w-full mx-auto">
          {features.slice(0, INITIAL_COUNT).map((feature, index) => (
            <div
              key={index}
              className="feature-card group relative card-glass p-6 transition-transform hover:-translate-y-1 flex items-center justify-center text-center flex-col h-full"
              ref={(el) => {
                if (el) (cardRefs.current as any[])[index] = el;
              }}
            >
              <div className="inline-flex items-center justify-center w-11 h-11 text-4xl text-white mb-3">
                {feature.icon}
              </div>
              <h3 className="text-white font-bold text-lg">{feature.title}</h3>
              <p className="mt-2 text-gray-300 text-sm leading-relaxed flex-1">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </section>
    </>
  );
};

export default Features;
